module.exports = __webpack_public_path__ + "img/analysis_revise_halfright.f8ec0d6c.svg";